import axios from "axios";
import { base_url, store_apis } from "../ApiConst";
import { axiosInstance } from "../axios";
import { Token } from "../Token";

/**
 * @template T
 * @typedef {import("axios").AxiosResponse<T>} AxiosResponse
 */
/**
 * @template T
 * @typedef {import("./types/base.types").BaseAPIResponse<T>} BaseAPIResponse
 */
/** @typedef {import("./types/store.types").StoreDashboardSummary} StoreDashboardSummary */

export const Search_Stores = async (
  isSearch,
  searchText,
  userLatitude,
  userLongitude,
  userPincode
) => {
  try {
    return await axiosInstance.get(store_apis.search_stores(isSearch), {
      useUserToken: false,
      params: {
        search_text: searchText,
        lat: userLatitude,
        long: userLongitude,
        pincode: userPincode,
      },
    });
  } catch (error) {
    throw error;
  }
};

export const Store_Registration = async (
  formData,
  userToken,
  contactNumber,
  contactPersonName,
  selectedOption,
  address,
  city,
  pincode,
  storeLat,
  storeLong,
  openingTime,
  closingTime
) => {
  try {
    const istDate = new Date(openingTime);
    // Converting to UTC and format in ISO 8601
    const utcDate = new Date(
      istDate.getTime() - istDate.getTimezoneOffset() * 60000
    );
    const isoString = utcDate.toISOString();
    const formattedOpenTime = new Date(isoString)
      .toISOString()
      .substring(11, 19);

    const istDat = new Date(closingTime);
    // Converting to UTC and format in ISO 8601
    const utcDat = new Date(
      istDat.getTime() - istDat.getTimezoneOffset() * 60000
    );
    const isostring = utcDat.toISOString();
    const formattedCloseTime = new Date(isostring)
      .toISOString()
      .substring(11, 19);

    let data = {
      owner_name: formData.ownerName,
      store_name: formData.businessName,
      email: formData.email,
      contact_number: contactNumber,
      business_registration_number: formData.registrationNumber,
      service_area_pin_code: null,
      store_type: selectedOption,
      address: address,
      city: city ?? null,
      pincode: pincode ?? null,
      latitude: storeLat ?? null,
      longitude: storeLong ?? null,
      landmark: formData.landMark,
      contact_person_name: contactPersonName ?? null,
      contact_person_number: formData.contactPersonNumber ?? null,
      buisness_type: formData.businessType,
      opening_time: openingTime && formattedOpenTime,
      closing_time: closingTime && formattedCloseTime,
      language_data: [
        {
          language: "1",
          address: formData.nepaliAddress,
          store_name: formData.nepaliName,
          city: formData.nepaliCity,
        },
      ],
    };

    return await axiosInstance.post(store_apis.store_registration(), data, {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};
export const Store_BankDetails = async (
  data,
  userToken,
  idNumber,
  idNumber2,
  chequeFile,
  idNumber1File,
  idNumber2File,
  prevChequeFile
) => {
  try {
    let params = new FormData();
    // Append form data fields to the FormData object
    params.append("service_area_pin_code", data?.areaPinCode);
    params.append("bank_name", data?.bank);
    params.append("account_number", data?.accountNumber);
    params.append("cheque_copy", chequeFile ? chequeFile : prevChequeFile);
    params.append("account_name", data?.accountHolderName);
    params.append("id_document_1", idNumber);
    params.append("id_document_2", idNumber2);
    params.append("country", data?.branch);
    idNumber1File && params.append("id_document_1_file", idNumber1File);
    idNumber2File && params.append("id_document_2_file", idNumber2File);
    // Use userToken from localStorage
    return await axiosInstance.post(store_apis.store_bank_details(), params, {
      useUserToken: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    throw error;
  }
};

//need to modify the apis
export const Store_View = async (payload) => {
  try {
    return await axios.post(
      `${base_url}/api/v0/store/product_list/${payload.store_id}/category/`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: Token,
        },
      }
    );
  } catch (error) {
    throw error;
  }
};

export const Store_SubCategory_View = async (payload) => {
  try {
    const { page, limit, ...bodyPayload } = payload;

    // Append page and limit as query parameters
    // const queryString = `?page=${page}&limit=${limit}`;

    return await axiosInstance.post(
      //   `api/v0/store/product_list/${payload.store_id}/category/${queryString}`,
      store_apis.store_subcategory_view(payload.store_id, page, limit),
      bodyPayload,
      { useUserToken: false }
    );
  } catch (error) {
    throw error;
  }
};

export const Set_Store = async (storeId, storeToken) => {
  try {
    const response = await axiosInstance.get(
      //   `api/v0/store/stores/details/${storeId}/`,
      store_apis.setStore(storeId),
      {
        useUserToken:true
        // headers: {
        //   Authorization: `Token ${storeToken}`,
        // },
      }
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
export const Store_Update = async (
  id,
  data,
  registerNumber,
  address,
  productImage,
  languageId,
  openingTime,
  closingTime
) => {
  try {
    const istDate = new Date(openingTime);
    // Convert to UTC and format in ISO 8601
    const utcDate = new Date(
      istDate.getTime() - istDate.getTimezoneOffset() * 60000
    );
    const isoString = utcDate.toISOString();
    const formattedOpenTime = new Date(isoString)
      .toISOString()
      .substring(11, 19);

    const istDat = new Date(closingTime);
    // Convert to UTC and format in ISO 8601
    const utcDat = new Date(
      istDat.getTime() - istDat.getTimezoneOffset() * 60000
    );
    const isostring = utcDat.toISOString();
    const formattedCloseTime = new Date(isostring)
      .toISOString()
      .substring(11, 19);

    let lan = [
      {
        language: "1",
        store: id,
        address: data.nepaliAddress,
        store_name: data.nepaliName,
        city: data.nepaliCity,
      },
    ];

    let params = new FormData();
    params.append("owner_name", data.ownerName);
    params.append("store_name", data.businessName);
    params.append("email", data.email);
    params.append("business_registration_number", registerNumber);
    params.append("city", data.city);
    params.append("landmark", data.landMark);
    params.append("address", address);
    params.append("contact_person_number", data?.contactPersonNumber);
    params.append("contact_person_name", data?.contactPersonName);
    params.append("buisness_type", data.businessType);
    params.append("language_data", JSON.stringify(lan));
    openingTime && params.append("opening_time", formattedOpenTime);
    closingTime && params.append("closing_time", formattedCloseTime);
    productImage && params.append("logo", productImage);

    return await axiosInstance.put(
      // `api/v0/store/stores/${id}/`,
      store_apis.updateStore(id),
      params,
      {
        useUserToken: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  } catch (error) {
    throw error;
  }
};
export const My_Store = async (userToken) => {
  try {
    const response = await axiosInstance.get(
      // "api/v0/store/stores/my_stores/",
      store_apis.my_store(),
      {
        useUserToken: true,
        headers: {
          Authorization: "Token " + userToken,
        },
      }
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
export const Create_Offers = async (
  userToken,
  storeId,
  data,
  amount,
  limit,
  percent,
  buyQuantity,
  freeQuantity,
  freeProduct
) => {
  try {
    let params = {
      store: storeId,
      offer_type: data.offer_type,
      percent: percent ? parseInt(percent.toString()) : null,
      amount: amount ? parseInt(amount.toString()) : null,
      // limited: limit ? parseInt(limit.toString()) : null,
      product: parseInt(data.product),
      send_per: data.send_per,
      status: "True",
      valid_from: data.valid_from,
      valid_to: data.valid_to,
    };

    // Add the additional fields for "bogo" offer type
    if (data.offer_type === "bogo") {
      params.buy_quantity = buyQuantity;
      params.free_quantity = freeQuantity;
      params.free_product = freeProduct;
    }

    return await axiosInstance.post(store_apis.create_offers(), params, {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};
export const Edit_Offer = async (
  id,
  userToken,
  storeId,
  data,
  amount,
  limit,
  percent,
  buyQuantity,
  freeQuantity,
  freeProduct
) => {
  try {
    let params = {
      store: storeId,
      offer_type: data.offer_type,
      percent: percent ? parseInt(percent.toString()) : null,
      amount: amount ? parseInt(amount.toString()) : null,
      limited: limit ? parseInt(limit.toString()) : null,
      product: parseInt(data.product),
      send_per: data.send_per,
      status: data.status,
      valid_from: data.valid_from,
      valid_to: data.valid_to,
    };
    if (data.offer_type === "bogo") {
      params.buy_quantity = buyQuantity;
      params.free_quantity = freeQuantity;
      params.free_product = freeProduct;
    }

    return await axiosInstance.put(
      // `api/v0/offer/offer-modify/${id}/`,
      store_apis.edit_offer(id),
      params,
      {
        useUserToken: true,
      }
    );
  } catch (error) {
    throw error;
  }
};

export const Offers_List = async (userToken, params) => {
  try {
    return await axiosInstance.get(store_apis.offer_list(), {
      useUserToken: true,
      params: params,
    });
  } catch (error) {
    throw error;
  }
};

export const Store_offers = async (userToken, storeId) => {
  try {
    return await axiosInstance.get(store_apis.store_offer(), {
      useUserToken: true,
      params: {
        store_id: storeId, // Pass store_id as a parameter
      },
    });
  } catch (error) {
    throw error;
  }
};

export const getOfferDetails = async (userToken, offerID) => {
  try {
    return await axiosInstance.get(store_apis.get_offer_details(offerID), {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

export const Store_Revenue = async (payload) => {
  // THIS API SHOULD BE DEPRECATED IN FAVOUR OF Store_Dashboard_Summary.
  try {
    return await axiosInstance.post(store_apis.store_revenue(), payload, {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};
/**
 * Order, integrated order and product totals for the logged-in seller's store
 * @param {string|object} [fromDate]
 * @param {string} [toDate]
 * @returns {Promise<AxiosResponse<BaseAPIResponse<StoreDashboardSummary>>>}
 */
export const Store_Dashboard_Summary = async (fromDate, toDate) => {
  try {
    const params = {};
    if (typeof fromDate === "object" && fromDate !== null) {
      Object.assign(params, fromDate);
    } else {
      if (fromDate) params.from_date = fromDate;
      if (toDate) params.to_date = toDate;
    }
    return await axiosInstance.get(store_apis.dashboard_summary, {
      useUserToken: true,
      params: Object.keys(params).length > 0 ? params : undefined,
    });
  } catch (error) {
    throw error;
  }
};

export const Todays_Offers = async () => {
  try {
    return await axiosInstance.get(store_apis.today_offers(), {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};
export const Coupons = async () => {
  try {
    return await axiosInstance.get(store_apis.coupons(), {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

export const GET_BANK_DETAILS = async (userToken) => {
  try {
    return await axiosInstance.get(store_apis.get_bank_details(), {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

export const Get_Store_Ratings = async (id) => {
  try {
    return await axiosInstance.get(store_apis.get_store_ratings(id), {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

export const Selected_Store_Rating = async (id) => {
  try {
    return await axiosInstance.get(store_apis.selected_store_ratings(id), {
      useUserToken: false,
    });
  } catch (error) {
    throw error;
  }
};

export const User_Store_Rating = async (payload, id) => {
  try {
    return await axiosInstance.post(
      store_apis.user_store_ratings(id),
      payload,
      {
        useUserToken: true,
      }
    );
  } catch (error) {
    throw error;
  }
};

export const getStoreAccountStatement = async (payload) => {
  try {
    const response = await axiosInstance.post(
      store_apis.get_store_account_statement(),
      payload,
      {
        useUserToken: true,
        maxBodyLength: Infinity,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching account statement:", error);
    throw error;
  }
};

export const getStoreAccountDashboard = async () => {
  try {
    const response = await axiosInstance.get(
      store_apis.get_store_account_dashboard(),
      {
        useUserToken: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error;
  }
};

export const getStoreAccountStatementPdf = async (payload) => {
  try {
    const response = await axiosInstance.post(
      store_apis.get_store_account_statement_pdf(),
      payload,
      {
        useUserToken: true,
        headers: {
          Cookie: "sessionid=9zdfl9az784rlg5gdrs402bdi7n9r7bb",
        },
        maxBodyLength: Infinity,
      }
    );
    return response.data.pdf_url;
  } catch (error) {
    console.error("Error fetching store account statement:", error);
    throw error;
  }
};

export const getStoreTransactionData = async (
  storeId,
  fromDate,
  tillDate,
  searchValue
) => {
  const payload = {
    store_id: storeId,
    from_date: fromDate,
    till_date: tillDate,
    search_value: searchValue,
  };

  try {
    const response = await axiosInstance.post(
      store_apis.get_store_transaction_data(),
      payload,
      {
        useUserToken: true,
        maxBodyLength: Infinity,
      }
    );
    // console.log(response.data, 'store transaction data is this ');
    return response.data;
  } catch (error) {
    console.error("Error fetching transaction data:", error);
    throw error;
  }
};

export const Review_list = async (userToken, currentPage, storeId) => {
  try {
    return await axiosInstance.get(store_apis.store_reviews(storeId), {
      useUserToken: true,
      params: {
        page: currentPage,
      },
    });
  } catch (error) {
    throw error;
  }
};

export const Search_Store_Reviews = async (payload, currentPage) => {
  try {
    return await axiosInstance.post(
      `api/v0/stores/store-rating/?page=${currentPage}`,
      payload,
      { useUserToken: true }
    );
  } catch (error) {
    throw error;
  }
};